<template>
  <div class="registerBox">
    <el-header height="46px">
      <span type="text" class="text" @click="loginTo">登录</span>
    </el-header>
    <!-- 手机号验证码 -->
    <div class="body-text">
      <span>忘记密码</span>
    </div>
    <div class="phoneBox" >
     <el-form :rules="rules" :model="changePaw" ref="changePaw" class="demo-ruleForm" label-width="0" >
      <el-form-item  prop="username"   >
       <el-input
        v-model="changePaw.username"
        maxlength="30"
        placeholder="请输入用户名"
        autocomplete="new-password"
      ></el-input>
      </el-form-item>
        <el-form-item
            prop="newPassword"
          >
            <el-tooltip class="item" effect="dark" content placement="top-end">
              <div slot="content">
                长度为8-16个字符
                <br />包括数字、字母、特殊字符两种或以上
              </div>
              <el-input
                type="password"
                v-model="changePaw.newPassword"
                show-password
                maxlength="20"
               auto-complete="new-password"
               placeholder="请输入新密码"
              ></el-input>
            </el-tooltip>
          </el-form-item>
          <el-form-item prop="checkPass"  >
            <el-tooltip class="item" effect="dark" content placement="top-end">
              <div slot="content">
                长度为8-16个字符
                <br />包括数字、字母、特殊字符两种或以上
              </div>
              <el-input
                type="password"
                v-model="changePaw.checkPass"
                placeholder="再次输入密码"
                show-password
                maxlength="20"
              ></el-input>
            </el-tooltip>
          </el-form-item>
      <!-- 手机号 -->
      <el-form-item
            prop="mobile"
          >
      <el-input
         v-model="changePaw.mobile"
        maxlength="11"
        placeholder="请输入手机号"
        onkeyup="value=value.replace(/[^\d]/g,'')"
        autocomplete="new-password"
      ></el-input>
      </el-form-item>
      <el-form-item
            prop="smsCode"
          >
      <el-input
         v-model="changePaw.smsCode"
        maxlength=""
        placeholder="请输入验证码"
      ></el-input>
      <span
      class="codeBtn"
      v-if="isShowGetCode"
      @click="getIdentifyCode">获取验证码</span>
      <span v-else class="codeBtn cancel-pointer"
      >{{ countdown }}s后可重试</span
      >
      </el-form-item>
      <el-button  type="primary" @click="phoneNext" class="bigBtn" style="width:100%;margin-top:20px;">确定</el-button>
     </el-form>
    </div>
    </div>
</template>
<script>
import { encryption } from '@/utils/util'
// import InputGroup from '@/components/inputGroup.vue' // 引入封装的组件
// import store from '@/store'
export default {
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.changePaw.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      active: 0,
      phone: '', // 手机号
      isShowGetCode: true,
      countdown: 60,
      checked: false,
      miMa: {
        passWord: '',
        passWord2: ''
      },
      changePaw: {},
      rules: {
        username: { required: true, message: '请输入用户名', trigger: 'blur' },
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          this.rule.mobile
        ],
        smsCode: { required: true, message: '请输入验证码', trigger: 'blur' },
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, message: '请输入至少8位的密码', trigger: 'blur' },
          // eslint-disable-next-line no-useless-escape
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z-`=\[\];',.~!@#$%^&*()_+|{}:"?]{8,16}$/, message: '密码设置不符合要求' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' },
          { min: 8, message: '请输入至少8位的密码', trigger: 'blur' },
          // eslint-disable-next-line no-useless-escape
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z-`=\[\];',.~!@#$%^&*()_+|{}:"?]{8,16}$/, message: '密码设置不符合要求' }
        ]
      },
      tuoYun: '1', // 托运
      code: '',
      smsCode: '', // 判断输入的是否正确
      registerId: '', // id
      businessFlg: '' // 业务类型
    }
  },
  mounted () {
  },
  methods: {
    loginTo () {
      this.$router.push({
        path: '/login'
      })
    },
    // 验证手机
    validateMobile (mobile) {
      return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(mobile)
    },
    next () {
      if (this.active++ > 2) this.active = 0
    },
    // 点击获取验证码
    getIdentifyCode () {
      if (this.changePaw.mobile == '') {
        this.$message.error('请输入手机号')
      } else if (!this.validateMobile(this.changePaw.mobile)) {
        this.$message.error('请正确输入手机号')
      } else {
        this.countDown()
        this.isShowGetCode = false
        let Authorization1 = encryption({
          data: { Basic: this.global.headerBasic },
          type: 'Base64',
          param: ['Basic']
        })
        this.$axios({
          headers: {
            Authorization: 'Basic ' + Authorization1.Basic
          },
          method: 'get',
          url: this.global.commonNameV2 + '/oauth/sendSMS',
          params: {
            mobile: this.changePaw.mobile,
            grant_type: 'mobile'
          }
        }).then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('发送成功请注意查收')
          } else {
            this.$message.error(res.message)
          }
        }).catch(error => {
          console.log('错误', error)
          this.$message.error(error.message)
        })
      }
    },
    countDown () {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
        }
      }, 1000)
    },
    // 确定
    phoneNext () {
      this.$refs.changePaw.validate((valid) => {
        if (valid) {
          this.changePaw.grant_type = 'forgetPassword'
          let data = encryption({
            data: this.changePaw,
            key: this.global.key,
            param: ['newPassword', 'checkPass']
          })
          let Authorization1 = encryption({
            data: { Basic: this.global.headerBasic },
            type: 'Base64',
            param: ['Basic']
          })
          this.$axios({
            headers: {
              Authorization: 'Basic ' + Authorization1.Basic
            },
            method: 'post',
            url: this.global.commonNameV2 + '/oauth/forgetpasswor',
            params: data
          }).then(res => {
            this.$message.success('修改成功')
            this.$router.push({
              path: '/login'
            })
          }).catch(error => {
            this.$message.error(error.message)
          })
        }
      })
    }

  }
}
</script>
<style lang="less" scoped>
/deep/body{
  width: 100%;
  height: 100%;
  position: relative;
  // background-color:#fff ;
}
.registerBox{
  width: 100%;
  height: 100%;
  background-color:#fff;
  position: absolute;
  left: 0;
  top: 0;
  .el-header {
    background-color: #0e6eec;
    line-height: 46px;
    .text{
      float: right;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
    }
  }
    .body-text{
      font-size: 19px;
      text-align: center;
      padding: 40px 0 50px 0;
      color: #409EFF;
    }
    .phoneBox{
      width: 20%;
      height: 200px;
      // border: solid 1px;
      // padding-top:50px;
      margin: 0 auto;
    }
    /deep/.el-form-item__content{
      position: relative;
    }
    .codeBtn{
        position: absolute;
        font-size: 14px;
        color: #409EFF;
        cursor: pointer;
        width: 120px;
        left: 73%;
    }
}

</style>
